import { useAppSelector } from 'app-redux/hooks'

import { CardType, defaultCard } from 'types/deck'

const useHoveredDeckCard = (): CardType => {
  const cardMap = useAppSelector(state => state.deck.cardMap)
  const hoveredCardId = useAppSelector(state => state.active.hoveredCardId)

  return cardMap[hoveredCardId] || defaultCard
}

export default useHoveredDeckCard
